export const TelegramIcon = () => {
  return (
    <svg
      width='20'
      height='18'
      viewBox='0 0 20 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M18.4368 0.112055C18.2771 0.173554 14.1283 1.85806 9.21732 3.85543C3.71713 6.09239 0.247856 7.52715 0.183272 7.59159C0.0454391 7.72905 -0.0290156 8.00317 0.0106013 8.22735C0.0784905 8.61147 0.103056 8.62361 2.67713 9.54633C4.64592 10.2521 5.04387 10.3807 5.12194 10.3363C5.17322 10.3072 5.743 9.93979 6.38812 9.51992C7.03325 9.10005 9.46904 7.5189 11.801 6.00623C16.1507 3.18472 16.1812 3.16685 16.1812 3.43911C16.1812 3.49663 14.7436 4.93311 12.1286 7.48842C9.89974 9.66648 8.02809 11.5017 7.9695 11.5667C7.86512 11.6825 7.85998 11.7301 7.71406 13.9474C7.60928 15.5391 7.57806 16.249 7.60879 16.3418C7.66038 16.4975 7.85734 16.6119 7.99428 16.5657C8.04752 16.5478 8.67443 15.9277 9.3874 15.1877C10.1004 14.4477 10.7005 13.8423 10.721 13.8423C10.7414 13.8423 11.7975 14.679 13.0678 15.7016C14.338 16.7242 15.4476 17.6004 15.5336 17.6487C15.8711 17.8385 16.3659 17.6889 16.5999 17.3263C16.6756 17.2091 17.0736 15.3639 18.349 9.21764C19.257 4.84131 20 1.19751 20 1.12022C20 0.836481 19.8943 0.592524 19.6665 0.350749C19.315 -0.0224647 18.9634 -0.0906969 18.4368 0.112055Z'
        fill='white'
      />
    </svg>
  );
};
